export default __webpack_public_path__ + "static/media/reset.202af6a1.svg";